<template>
  <div class="demo-message-wrapper" @click="close">
    <!-- Modal content -->
    <div class="modal-content">
      <button
        type="close"
        :title="getTooltips['close']"
        @click="close"
        name="close"
        class="close-button"
        :style="`width:${offset.iconSize}px; height:${offset.iconSize}px; top:${offset.topOffset}%!important;right:${offset.rightOffset}%!important;`"
      >
        <svg fill="#ffffff" viewBox="0 0 24 24">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            fill="rgb(144, 144, 144)"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <p>
        <span :style="`font-size:${offset.fontSize}`" class="text-message">{{ message.text }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'tr-demo-messages',
  data: () => {
    return {
      message: {
        text: 'Funkcjonalność dostępna w pełnej wersji.',
      },
    };
  },
  methods: {
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
    close() {
      this.$emit('close');
    },
  },
  computed: {
    modalActive() {
      return this.$store.getters.modalActive;
    },
    offset() {
      let iconSize = 64;
      let topOffset = 1;
      let rightOffset = 0.1;
      let fontSize = '2.3vh';
      let width = $('#scaleable-wrapper').width();
      if (width >= 1920) {
        iconSize = 50;
      } else if (width >= 1440 && width < 1920) {
        iconSize = 50;
        // fontSize = '2.3vh';
      } else if (width >= 1280 && width < 1440) {
        iconSize = 47;
        // fontSize = '1.3rem';
      } else {
        iconSize = 32;
        // fontSize = '1rem';
      }
      return { topOffset, fontSize, rightOffset, iconSize };
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';
/* The Modal (background) */
.demo-message-wrapper {
  position: absolute;
  top: 0;
  left: 0%;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 25% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 50%;
    height: 15%;
    z-index: 101;
    display: flex;
    justify-content: center;
    align-items: center;

    .close-button {
      pointer-events: auto;
      position: absolute;
      top: 0;
      right: 0;
      opacity: 1;
      z-index: 1003;
      cursor: pointer;
      outline: none;
      border: none;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      top: -47px !important;
      right: -50px !important;
      display: flex;
      transform: scale(1);
      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      &:hover {
        svg {
          path:first-child {
            fill: #5d5d5d;
            transition: all 0.4s ease;
          }
        }
        background-color: $borderColor;
        transform: scale(1.1);
        transition: all 0.4s ease;
        // opacity: 1;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .text-message {
      font-size: 2.3vh;
      -webkit-text-size-adjust: none;
    }
  }
}
</style>
